<template>
  <div class="wrap">
    <div class="head">
      <div class="eyebrow">SETH HOTELS</div>
      <h1 class="title">{{ ui.buffetTitle }}</h1>
      <p class="sub">{{ ui.buffetSub }}</p>
    </div>

    <div v-if="store.booting" class="state">{{ ui.cargando }}</div>

    <div v-else-if="store.categorias.length" class="grid">
      <button
        v-for="(c, i) in store.categorias"
        :key="c.id"
        class="buffet"
        :style="accent(i)"
        @click="navigateCat(c.id)"
      >
        <span class="thumb" :style="thumb(i)">{{ initialsOf(c.nombre) }}</span>
        <span class="text">
          <span class="name">{{ c.nombre }}</span>
          <span v-if="c.descripcion" class="desc">{{ c.descripcion }}</span>
        </span>
        <svg class="chevron" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="var(--sand-400)" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="m9 18 6-6-6-6" /></svg>
      </button>
    </div>

    <div v-else-if="store.error" class="state">
      <div class="state-title">{{ ui.errorCarga }}</div>
      <app-button variant="secondary" pill @click="retry">{{ ui.reintentar }}</app-button>
    </div>

    <div v-else class="state">{{ ui.sinBuffets }}</div>
  </div>
</template>

<script>
import { UI, PAL, initialsOf } from '@/data'
import { store, navigateCat, retry } from '@/store'
import AppButton from './ui/AppButton.vue'

export default {
  name: 'LandingView',
  components: { AppButton },
  data() {
    return { store }
  },
  computed: {
    ui() { return UI[store.locale] || UI.es }
  },
  methods: {
    navigateCat,
    retry,
    initialsOf,
    thumb(i) {
      const p = PAL[i % 4]
      return { background: p[0], color: p[1] }
    },
    accent(i) {
      return { borderLeftColor: PAL[i % 4][1] }
    }
  }
}
</script>

<style scoped>
.wrap { max-width: 760px; margin: 0 auto; }
.head { margin-bottom: 24px; }
.eyebrow {
  font-size: 0.7rem;
  letter-spacing: 0.18em;
  text-transform: uppercase;
  color: var(--seth-gold-600);
  font-weight: 600;
  margin-bottom: 8px;
}
.title {
  font-family: var(--font-display);
  font-weight: 300;
  font-size: 1.9rem;
  color: var(--seth-navy);
  line-height: 1.1;
  margin: 0;
}
.sub {
  font-size: 0.95rem;
  color: var(--ink-700);
  margin: 10px 0 0;
  max-width: 52ch;
  line-height: 1.5;
}

.grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 14px;
}
.buffet {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 16px;
  background: #fff;
  border: 1px solid var(--sand-200);
  border-left: 4px solid var(--sand-200);
  border-radius: 14px;
  box-shadow: var(--shadow-xs);
  cursor: pointer;
  text-align: left;
  transition: all 240ms var(--ease-out);
}
.buffet:hover {
  box-shadow: 0 8px 24px rgba(20, 36, 46, 0.12);
  transform: translateY(-2px);
}
.thumb {
  width: 52px;
  height: 52px;
  border-radius: 12px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: var(--font-display);
  font-weight: 600;
  font-size: 1.05rem;
}
.text { flex: 1; min-width: 0; display: flex; flex-direction: column; gap: 4px; }
.name {
  font-family: var(--font-display);
  font-weight: 600;
  font-size: 1.1rem;
  color: var(--seth-navy);
  line-height: 1.2;
}
.desc { font-size: 0.85rem; color: var(--ink-500); line-height: 1.4; }
.chevron { flex-shrink: 0; }

.state { text-align: center; padding: 48px 20px; color: var(--ink-500); }
.state-title { font-size: 0.95rem; margin-bottom: 14px; }
.state .seth-btn { margin: 0 auto; }
</style>
